import React, {PropTypes} from 'react';
import style from './style';

class NonLoggedLayout extends React.Component {
  static contextTypes = {
    muiTheme: PropTypes.object
  };

  render() {
    let {bgComponent}  = this.context.muiTheme.nonLogged;
    return React.createElement(bgComponent, {
      className: style.bgImage,
      children: (
        <div className={style.layout}>
          <div className={style.container}>
            {this.props.children}
          </div>
        </div>
      )
    });
  }
}

export default NonLoggedLayout;




// WEBPACK FOOTER //
// ./src/components/NonLoggedLayout/index.jsx